import React from 'react';
import SingleSelectDropdown, { SingleSelectDropdownProps } from '../SingleSelectDropdown';
import { DropdownOption } from 'components/DropdownSelect/dropdown.types';
import { MultiselectDropdownProps } from '../../MultiSelectDropdown/MultiselectDropdown';

interface AnyStringSingleSelectDropdownInterface {
  strings: string[];
  selectedString?: string;
  onChange: (newActivityState?: DropdownOption) => void;
  containedLabel?: boolean;
  inputProps?: Omit<SingleSelectDropdownProps['inputProps'], 'sx'>;
}

const AnyStringSingleSelectDropdown = ({
  selectedString,
  strings,
  onChange,
  containedLabel,
  inputProps,
}: AnyStringSingleSelectDropdownInterface) => {
  const options = strings.map((string, i) => ({ id: i, name: string }));

  const selected = options.find((option) => option.name === selectedString);

  return (
    <SingleSelectDropdown
      fullWidth
      allOptions={options}
      setSelected={onChange}
      selected={selected}
      fieldLabel='Status'
      containedLabel={containedLabel}
      inputProps={inputProps}
    />
  );
};

export default AnyStringSingleSelectDropdown;
